export default __webpack_public_path__ + "static/media/marauders-map-v5.1-01-00.799490dd.jpg";